<template>
    <div class="CriterionDateDurationInput">
        <FormElement :label="hideTitle ? null : form.schema.title">
            <template v-if="form.schema.description" #labelHint>
                <div
                    v-tooltip="form.schema.description"
                    class="CriterionDateDurationInput__hintIcon"
                >
                    <FontAwesomeIcon :icon="faQuestionCircle" />
                </div>
            </template>
            <FormInput
                :invalid="showValidationErrors && (showError || accessed) && hasError"
                force-error-slot
                force-action-slot
            >
                <input
                    type="number"
                    :disabled="rbacDisabled"
                    :value="value"
                    :min="form.schema.minimum || 0"
                    :max="form.schema.maximum || 999"
                    @input="onInput"
                >
                <span>{{ unit }}</span>
                <template v-if="showValidationErrors && (showError || accessed) && error" #errorMessage>
                    {{ error }}
                </template>
                <template v-if="deletable || rbacDisabled" #actionButtons>
                    <LockInputIcon v-if="rbacDisabled" />
                    <NewButton
                        v-else-if="deletable"
                        variant="flat"
                        size="icon-sm"
                        color="secondary"
                        class="JsonSchemaForm__deleteIcon"
                        @click="$emit('delete')"
                    >
                        <slot name="deleteIcon">
                            <EidIcon :icon-src="faXmark" alt="delete" />
                        </slot>
                    </NewButton>
                </template>
            </FormInput>
        </FormElement>
    </div>
</template>

<script lang="ts">
    import { Component, Prop } from '@evidentid/vue-property-decorator';

    import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
    import { faXmark } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { FormElement, FormInput } from '@evidentid/dashboard-commons/components/Form';
    import LockInputIcon from '@evidentid/dashboard-commons/components/LockInputIcon/LockInputIcon.vue';
    import { JsonFormBase } from '@evidentid/json-schema/interfaces/JsonForm';
    import { JsonSchemaInteger } from '@evidentid/json-schema/interfaces/JsonSchema';

    import NewButton from '@/components/new-button/NewButton.vue';
    import AbstractCriterionInput
        from '@/modules/decisioning-criteria/components/CriterionInputComponents/AbstractCriterionInput';

    @Component({
        emits: [ 'delete', 'input' ],
        components: { EidIcon, FormInput, FontAwesomeIcon, FormElement, LockInputIcon, NewButton },
    })
    export default class CriterionDateDurationInput
        extends AbstractCriterionInput<JsonFormBase<JsonSchemaInteger>, number> {
        @Prop({ type: String, default: 'days' })
        private unit!: 'days' | 'months';

        private faXmark = faXmark;
        private faQuestionCircle = faQuestionCircle;

        private onInput(event: InputEvent): void {
            const inputValue = Number((event.target as HTMLInputElement).value);
            this.$emit('input', inputValue);
        }
    }
</script>
